import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}\n",{ moduleName: "sh-www/templates/message-center/archive/thread.hbs" })